/**
 * shell/connText.ts —— **连接态人面文案「单一来源」**（★20261011 大王令「对齐旧树」）
 *
 * 由来：连接态文案原散在 `AppShell.tsx`（顶栏）与 `SettingsPanel.tsx`（设置面板「连接」节）——
 *   设置面板直接渲染了**裸 token**（`open`）＝开发者口径上脸（大王报障：『"open" 也是个文字污染』）。
 *   本件收口两处：**表只此一份**，两处消费同一返回值。
 *
 * 语义来源（逐字）：旧树 `transport/connection.js::statusText` ——
 *   `paused: '连接已暂停 / 自动重连中'`／`reconnecting: '自动重连中'`／`failed: '连接失败'`／
 *   `hover: '立即重连'`／`pageRetry: '加载更早失败 / 重试'`；
 *   纪律（§8.4.1 纪律①）：**心跳超时 ≠ 网络失败** ⇒ 断流只表达「暂停/重连中」，**绝不报「网络失败」**。
 */

import type { AttachmentStatus } from "../assembly/input/attachments";

/** 连接态 → 人面文案（设置面板「连接」节用；任何 token 都不上人面） */
export const TRANSPORT_STATUS_TEXT: Record<string, string> = {
  idle: "未连接",
  connecting: "连接中",
  open: "已连接",
  reconnecting: "重连中",
  closed: "已断开",
};

/** 输入区上方**连接条**用（★旧树位）：空串 ⇒ 不渲染该条（旧树 `v-if="connectionHint"` 语义，正常态静默） */
export const CONN_HINT_TEXT: Record<string, string> = {
  idle: "未连接",
  connecting: "连接中",
  reconnecting: "自动重连中",
  closed: "连接已暂停 / 自动重连中",
  open: "",                                   // 正常态：不显示（旧树口径）
};

/** 附件上传条状态 → 人面文案（★20261012 AUD3B FE-N-4：原 `components/composer/ComposerUploadBar.tsx` 局部副本上收；表只此一份） */
export const UPLOAD_STATUS_TEXT: Record<AttachmentStatus, string> = {
  pending: "待上传",
  uploading: "上传中",
  done: "已上传",
  error: "上传失败",
};

/** 人面取文案（未知态 ⇒ 原样回落，**不吞**） */
export function connTextOf(status: string): string {
  return TRANSPORT_STATUS_TEXT[status] ?? status;
}
